import React, { Component } from 'react';
import RegularButton from '../components/CustomButtons/Button';
import SyncStockxIDModal from '../Modal/SyncStockxIDModal';

export default class ValueOrButtonRenderer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      productId: this.props.data?.id,
    };
  }

  handleClick = e => {
    this.setState({ openModal: true });
  };

  handleClose = (status) => {
    this.setState({ openModal: false });
    if (status && this.props?.handleCallback) {
      this.props.handleCallback();
    }
  }

  render() {
    return this.props.value && this.state.productId ? (
      <span>{this.props.value}</span>
    ) : (
      <>
        <RegularButton
          color="info"
          size="sm"
          round
          onClick={this.handleClick}
        >
          Add
        </RegularButton>
        {this.state.openModal && (<SyncStockxIDModal productId={this.state.productId} handleClose={this.handleClose} />)}
      </>
    );
  }
}
